module.exports = __webpack_public_path__ + "static/media/eirich-mesalec-s.d51f232a.webp";